export default __webpack_public_path__ + "static/media/safari.dff9cc0c.svg";